import { getOssProxyOrFail } from "./api";
import { z } from "zod";

const cxFeatureFlagsSchema = z.object({ cxsWithDashV2FeatureFlag: z.literal(true).optional() });
export type CxFeatureFlags = z.infer<typeof cxFeatureFlagsSchema>;

const FEATURE_FLAGS_URL = `/medical/v1/feature-flags`;

export async function getDashboardFeatureFlagsForUser(): Promise<CxFeatureFlags> {
  const apiOssProxy = getOssProxyOrFail();
  try {
    const resp = await apiOssProxy.get(FEATURE_FLAGS_URL);
    return cxFeatureFlagsSchema.parse(resp.data);
  } catch (error) {
    return {};
  }
}
